// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3oSVn","gfeWrapper":"CalendarEvent_gfeWrapper__2JzHJ"};